import { useData } from "./DataContext.js";

import Badge from "react-bootstrap/Badge";

import { BsLightbulbFill } from "react-icons/bs";

import ApplicationBadge from "./ApplicationBadge";
import ReliabilityBadge from "./ReliabilityBadge";

export default function SolutionTitle (props)
{
    const gData = useData();

    const solution = gData.state.solutions[props.solutionId];
    const solutionContent = gData.content.solutions[props.solutionId];

    let solutionTitle = (<span className="opacity-25">Solution inconnue</span>);
    if (props.newSolution) solutionTitle = (<span className="fw-bold">Nouvelle solution</span>);
    else if (solution.found) solutionTitle = (<span>{solutionContent.title}</span>);

    const size = props.size === undefined ? "sm" : props.size;
    const iconSize = size === "sm" ? "fs-6" : "fs-5";
    const titleSize = size === "sm" ? "fs-6 fw-normal " : "fs-5 fw-normal ";
    const gap = size === "sm" ? "gap-1" : "gap-2";

    const width = gData.content.params.documentWidth || "auto";
    const height = gData.content.params.documentHeight || "auto";

    let bgColor = "dark";
    let textColor = "white";
    let borderColor = "dark";

    /* if (solution.applied !== null)
     * {
       bgColor = solution.applied ? "success" : "danger";
       textColor = solution.applied ? "white" : "white";
       borderColor = solution.applied ? "success" : "danger";
     * } */

    return (
	<div className="d-flex align-items-stretch gap-1">
	    <Badge bg={bgColor} text={textColor} className={"border-0 border-" + borderColor + " d-inline-flex align-items-center px-2 py-2 " + gap} style={{ minWidth: width, width, height }}>
		<BsLightbulbFill className={iconSize + ((props.newSolution || solution.found) ? "" : " opacity-25")}/>
		<span className={titleSize + " d-inline-block text-truncate"}>{solutionTitle}</span>
	    </Badge>
	    {(solution.found && !props.simple) && (
		<>
		    <ApplicationBadge solutionId={props.solutionId}/>
		    <ReliabilityBadge solutionId={props.solutionId}/>
		</>
	    )}
	</div>
    );
}

